import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {withRouter} from "react-router-dom"
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import StarIcon from "@material-ui/icons/StarBorder";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import actions from "../redux/actions";
import {firestore} from "../firebase"

const useStyles = makeStyles((theme) => ({
  "@global": {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: "none",
    },
  },
  link: {
    margin: theme.spacing(1, 1.5),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[700],
  },
  cardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginBottom: theme.spacing(2),
  },
  backdrop: {
    zIndex: 15000
  },
  plansContainer:{
    justifyContent: "center",
    alignItems: "center"
  }
}));

function Plans({ history }) {
  const classes = useStyles();
  const { plans = [], loading = false, newUser = {} } = useSelector((state) => ({
    plans: state.plans,
    loading: state.loading,
    newUser: state.newUser
  }));
  const dispatch = useDispatch();

  useEffect(() => {
  
    if (!newUser.uid) {
      history.push("/");
    }else {
      dispatch({
        type: actions.GET_PLANS,
      });
    }

  }, []);

  const selectPlan = (plan) => {
    dispatch({
      type: actions.SET_STATE,
      payload: {
        selectedPlan: plan
      }
    })
    history.push("/payment")
  }
  return (
    <>
      <CssBaseline />
      <Backdrop open={loading} className={classes.backdrop}>
        <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
      </Backdrop>
      <Container maxWidth="sm" component="main" className={classes.heroContent}>
        <Typography
          component="h1"
          variant="h4"
          align="center"
          color="textPrimary"
          gutterBottom
        >
          Choose the plan
        </Typography>
        <Typography
          component="h1"
          variant="h6"
          align="center"
          color="textsecondary"
          gutterBottom
        >
          Every month, hundreds of new 2D, 3D characters and templates will be added. Just 3.99$ per month. Value for money. Upgrade now!.
        </Typography>
      </Container>
      <Container maxWidth="md" component="main">
        <Grid container spacing={5} className={classes.plansContainer}>
          {plans.map((tier) => (
            <Grid
              item
              key={tier.productName}
              xs={12}
              sm={tier.preferred ? 12 : 6}
              md={4}
            >
              <Card>
                <CardHeader
                  title={tier.productName}
                  subheader={tier.subheader}
                  titleTypographyProps={{ align: "center" }}
                  subheaderTypographyProps={{ align: "center" }}
                  action={tier.preferred ? <StarIcon /> : null}
                  className={classes.cardHeader}
                />
                <CardContent>
                  <div className={classes.cardPricing}>
                    <Typography component="h2" variant="h3" color="textPrimary">
                      ${tier.price}
                    </Typography>
                    <Typography variant="h6" color="textSecondary">
                      /mo
                    </Typography>
                  </div>
                  <ul>
                    {tier.features.map((line) => (
                      <Typography
                        component="li"
                        variant="subtitle1"
                        align="center"
                        key={line}
                      >
                        {line}
                      </Typography>
                    ))}
                  </ul>
                </CardContent>
                <CardActions>
                  <Button fullWidth variant="contained" color="primary" onClick={() => selectPlan(tier)}>
                    Get Started
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
}

export default withRouter(Plans)
